import DOMPurify from 'dompurify'; 

import { trigger_text_editor, trigger_date_picker, trigger_sort, order_sort, content_sort, random_string } from './../function/common.js';
import { set_button_state, set_map_state } from './../runtime/registerMap.js';
import { notification } from './../function/notification.js';
import { api } from './../function/api.js';
import { Trip, Media, Content } from './../classes.js';

//elements
import { text__element } from './../element/text.js';
import { event__element } from './../element/event.js';
import { image__element } from './../element/image.js';
import { youtube__element } from './../element/youtube.js';
import { trip_block__element } from './../element/trip_block.js';

export class cEditor {
	
	constructor() {
		
		/**PREPARE VARS**/
		this.inactive_options =  `
			<div class="options">
				<span class="edit material-symbols-outlined">edit</span>
			</div>
		`;
		
		this.active_options =  `
			<div class="options">
				<span class="confirm material-symbols-outlined">check</span>
				<span class="drag material-symbols-outlined">drag_pan</span>
				<span class="delete material-symbols-outlined">delete</span>
			</div>
		`;
		
		this.trip_options =  `
			<div class="options">
				<span class="confirm material-symbols-outlined">check</span>
			</div>
		`;
		
		this.new_elements =  `
			<div class="clear"></div>
			<div class="new_elements">
				<div class="elements_menu--trigger active_listener">
					<span class="material-symbols-outlined">
						add
					</span>
				</div>
				<div class="elements_menu active_target">
					<div class="element" data-element="text">
						<span class="material-symbols-outlined">
							text_fields
						</span>
						<p>Text</p>
					</div>
					<div class="element" data-element="event">
						<span class="material-symbols-outlined">
							event
						</span>
						<p>Event</p>
					</div>
					<div class="element" data-element="image">
						<span class="material-symbols-outlined">
							image
						</span>
						<p>Image/Gallery</p>
					</div>
					<div class="element" data-element="video">
						<span class="material-symbols-outlined">
							video_camera_back
						</span>
						<p>Video</p>
					</div>
					<div class="element" data-element="youtube">
						<span class="material-symbols-outlined">
							video_frame_copy
						</span>
						<p>YouTube Embed</p>
					</div>
					
					<div class="element--group btn--add_block">
						<span class="material-symbols-outlined">
							tab_group
						</span>
						Content Group
					</div>
				</div>
			</div>
		`;
		
		/**PREPARE LISTENERS**/
		$('body').on('click', '.options .edit', {obj: this}, function(e){
			e.preventDefault();
			
			let $target = $(this).closest('.editor');
			let el_id = $target.attr('data-el_id');
			let block_id = $target.attr('data-block_id');
			
			Trip.switch_element(el_id, block_id, true);
			
			trigger_date_picker(Trip.default_date);
			trigger_sort();
		});
		
		$('body').on('click', '.options .delete', {obj: this}, async function(e){
			e.preventDefault();
			
			let $target = $(this).closest('.editable');
			let el_id = $target.data('el_id');
			let block_id = $target.data('block_id');
			
			if(isNaN(el_id)){
				//this has not been saved, just remove it from the object and display
				//clean object
				if(Content.edit){
					delete Content.content.e[el_id];
				}else{
					delete Trip.content.b[block_id].e[el_id];
				}
				//clean display
				$target.remove();
				
			}else{
				
				//this has been saved, remove it from the database then from object and display
				let delete_element = new FormData();
				delete_element.append('el_id', el_id);
				delete_element.append('block_id', block_id);
				
				//post
				let response = await api('/api/element/delete', delete_element);
				
				//response
				if(response.error){
					notification(response.message.join('<br/>'));
				}else{
					//clean object
					if(Content.edit){
						delete Content.content.e[el_id];
					}else{
						delete Trip.content.b[block_id].e[el_id];
					}
					//clean display
					$(`.e[data-el_id="${el_id}"][data-block_id="${block_id}"]`).remove();
				}
				
			}
		});
		
		$('body').on('click', '.options .confirm', {obj: this}, function(e){
			e.preventDefault();
			
			let $target = $(this).closest('.editable');
			let el_id = $target.data('el_id');
			let block_id = $target.data('block_id');
			let input_name = '';
			
			//on confirm, update the loaded content to display it correctly
			if(block_id == 'trip'){
				$target.find('input').each(function(index){
					Trip.content[block_id][$(this).attr('name')] = $(this).val();
				});
			}else{
				$target.find('input, file, textarea, select').each(function(index){
					
					//get the complex 'name', remove characters, convert to array, get the last entry
					input_name = $(this).attr('name').replaceAll("]", "").split('[').at(-1);
					//update the DATA
					if($(this).attr('type') != 'file'){
						Trip.content.b[block_id].e[el_id].c[input_name] = $(this).val();
					}
						
				});
			}

			Trip.switch_element(el_id, block_id, false);
			set_map_state();
		});
		
		$('body').on('click', '.new_elements .element', {obj: this}, function(e){
			let $target = '';
			if($('.trip__block').length > 0){
				$target = $(this).closest('.trip__block');
			}else{
				$target = $(this).closest('.the_content');
			}
			let block_id = $target.data('block_id');
			let el_id = random_string(9);
			let m_id = random_string(9);
			let type = $(this).data('element');
			let data = e.data.obj.create_empty_data(type, block_id, el_id, m_id);
			
			e.data.obj.close_elements_menu();
			
			e.data.obj.add_element(type, data, block_id);
		});
		
		
		$('body').on('click', '.media-position-btn, .media-size-btn', {obj: this}, function(e){
			e.preventDefault();
			
			//**** UPDATE ACTIVE STATE
			if($(this).hasClass('media-position-btn')){
				$('.media-position-btn').removeClass('active');
				$(this).addClass('active');
			}
			
			if($(this).hasClass('media-size-btn')){
				$('.media-size-btn').removeClass('active');
				$(this).addClass('active');
			}
			
			//**** SET VARS
			let target = $(this).closest('.editable');
			let block_id = target.data('block_id');
			let el_id = target.data('el_id');
			let position = $('.media-position-btn.active').data('position');
			let size = $('.media-size-btn.active').data('size');
			let class_size = 'media__size--'+size;
			let class_position = 'media__position--'+position;
			
			//**** UPDATE TRIP OBJECT
			if($('.trip__block').length > 0){
				Trip.content.b[block_id].e[el_id].c['media_size'] = size;
				Trip.content.b[block_id].e[el_id].c['media_position'] = position;
			}else{
				Content.content.e[el_id].c['media_size'] = size;
				Content.content.e[el_id].c['media_position'] = position;
			}
			
			target.find('input.media_size').val(size);
			target.find('input.media_position').val(position);
			
			//**** UPDATE DISPLAY
			target.removeClass(`
				media__position--left 
				media__position--center 
				media__position--right
				media__size--small
				media__size--medium
				media__size--full
			`);
			target.addClass(`${class_size} ${class_position}`);
			
		})
		
		$('body').on('click', '.btn--add_block', {obj: this}, function(e){
			e.preventDefault();
			
			//set vars
			let $target = $(this).closest('.trip__block');
			let order = parseInt($target.find('.block_order').val()) + 1;
			let $block = '';
			let block_id = random_string(9); //a random ID that will be updated once it hits the database
			
			e.data.obj.close_elements_menu();
			
			//add this to the Trip object with some default values
			Trip.content.b[block_id] = {
				'id': block_id
				, 'name': 'New Content Group'
				, 'order': order
				, 'priority': 1
			};
			Trip.content.b[block_id].e = {};
			
			//get the display object
			$block = trip_block__element(Trip.content.b[block_id], true);
			$block.append(e.data.obj.new_elements); //e.data.obj contains 'this' class object
			
			//add to the DOM
			$target.after($block);
			
			//refresh the order of all blocks
			order_sort();
		});
		
		$('body').on('click', '.trip__block_title', {obj: this}, function(e){
			let block_id = $(this).closest('.trip__block').attr('data-block_id');
			
			if(!$(this).hasClass('trip__block_title--edit')){
			
				const $input = $('<input/>', {
					'class': 'trip__block_title trip__block_title--edit',
					'name': `b[${block_id}][name]`,
					'val': $(this).text(),
				});
				
				$(this).replaceWith($input);
				$input.focus();
			}
		});
	}
	
	render(){
		//prepare .editor elements with the appropirate systems
		if(document.querySelector('.editor')){
			$('.editor').append(this.inactive_options);
		}
		if(document.querySelector('.editable')){
			$('.editable').append(this.active_options);
		}
	}
	
	add_element(type, data, block_id, replace = false){
		let $content = '';
		
		//get an empty version of the element we need
		switch(type){
			case 'text':
				$content = text__element(data, true);
				break;
				
			case 'event':
				$content = event__element(data, true);
				break;
				
			case 'image':
				$content = image__element(data, true);
				$content.addClass('the-media-focus');
				Media.open();
				break;
				
			case 'video':
				$content = image__element(data, true);
				$content.addClass('the-media-focus');
				Media.open();
				break;
				
			case 'youtube':
				$content = youtube__element(data, true);
				break;
		}
		
		//e.data.obj contains 'this' object
		if(block_id == 'trip'){
			$content.append(this.trip_options);
		}else{
			$content.append(this.active_options);
		}
		
		if(replace){
			$(`.e[data-el_id=${data.id}]`).replaceWith($content);
		}else{
			if($('.trip__block').length > 0){
				$(`.trip__block[data-block_id=${block_id}]`).find('.new_elements').before($content);
			}else{
				$(`.the_content`).find('.new_elements').before($content);
			}
		}
		
		//load in the supporting systems for inputs
		
		trigger_text_editor();
		trigger_date_picker(Trip.default_date);
		order_sort();
		content_sort();
		trigger_sort();
		
		$('.btn--marker').each(function(index){
			if(Number.isInteger(Number($(this).attr('data-marker'))) && $(this).attr('data-marker') != ''){
				set_button_state($(this), 'update');
			}
		});
	}
	
	close_elements_menu(){
		if($('.elements_menu').hasClass('active')){
			$('.elements_menu--trigger').removeClass('active');
			$('.elements_menu').removeClass('active');
		}
	}
	
	create_empty_data(type, block_id = random_string(9), el_id = random_string(9), m_id = random_string(9)){
		let data = {}
		
		if($('.trip__block').length > 0){
			//add prepare the Trip object for this new element
			if(typeof(Trip.content.b[block_id].e) == 'undefined'){
				//required if the first element in a block
				Trip.content.b[block_id].e = {};
			}
			if(typeof(Trip.content.b[block_id].e[el_id]) == 'undefined'){
				//element defaults
				Trip.content.b[block_id].e[el_id] = {};
				Trip.content.b[block_id].e[el_id].id = el_id;
				Trip.content.b[block_id].e[el_id].block_id = block_id;
			}
			if(typeof(Trip.content.b[block_id].e[el_id].c) == 'undefined'){
				//content defaults
				Trip.content.b[block_id].e[el_id].c = {};
			}
			if(typeof(Trip.content.b[block_id].e[el_id].m) == 'undefined'){
				//marker defaults
				Trip.content.b[block_id].e[el_id].m = {};
				Trip.content.b[block_id].e[el_id].m[m_id] = {};
				Trip.content.b[block_id].e[el_id].m[m_id].id = m_id;
				Trip.content.b[block_id].e[el_id].m[m_id].type = 1;
			}
			
			//get an empty version of the element we need
			switch(type){
				case 'text':
					//set default text elements
					Trip.content.b[block_id].e[el_id].type = 'text';
					Trip.content.b[block_id].e[el_id].c['text'] = '';
					break;
					
				case 'event':
					//set default event elements
					Trip.content.b[block_id].e[el_id].type = 'event';
					Trip.content.b[block_id].e[el_id].c['style'] = '1';
					Trip.content.b[block_id].e[el_id].c['name'] = '';
					Trip.content.b[block_id].e[el_id].m[m_id]['id'] = m_id;
					Trip.content.b[block_id].e[el_id].c['date'] = '';
					Trip.content.b[block_id].e[el_id].c['time'] = '';
					Trip.content.b[block_id].e[el_id].c['description'] = '';
					Trip.content.b[block_id].e[el_id].c['expenses'] = '';
					Trip.content.b[block_id].e[el_id].c['location_link'] = '';
					Trip.content.b[block_id].e[el_id].c['directions_link'] = '';
					
					Trip.content.b[block_id].e[el_id].fields = {
						'map': 1
						, 'date_time': 1
						, 'description': 1
						, 'expenses': 0
						, 'location_link': 1
						, 'directions_link': 1
					};
					
					break;
					
				case 'image':
					//set default image elements
					Trip.content.b[block_id].e[el_id].type = 'image';
					Trip.content.b[block_id].e[el_id].c['media_id'] = '';
					Trip.content.b[block_id].e[el_id].c['media_position'] = 'center';
					Trip.content.b[block_id].e[el_id].c['media_size'] = 'full';
					Trip.content.b[block_id].e[el_id].c['media_gallery'] = '';
					
					break;
				case 'video':
					Trip.content.b[block_id].e[el_id].type = 'video/mp4';
					Trip.content.b[block_id].e[el_id].c['media_id'] = '';
					Trip.content.b[block_id].e[el_id].c['media_position'] = 'center';
					Trip.content.b[block_id].e[el_id].c['media_size'] = 'full';
					Trip.content.b[block_id].e[el_id].c['media_gallery'] = '';
					break;
				
				case 'youtube':
					Trip.content.b[block_id].e[el_id].c['video'] = '';
					break;
			}
			
			data = Trip.content.b[block_id].e[el_id];
			
		}else{
			
			//add prepare the Trip object for this new element
			if(typeof(Content.content.e) == 'undefined'){
				//required if the first element in a block
				Content.content.e = {};
			}
			if(typeof(Content.content.e[el_id]) == 'undefined'){
				//element defaults
				Content.content.e[el_id] = {};
				Content.content.e[el_id].id = el_id;
				Content.content.e[el_id].block_id = block_id;
			}
			if(typeof(Content.content.e[el_id].c) == 'undefined'){
				//content defaults
				Content.content.e[el_id].c = {};
			}
			
			switch(type){
				case 'text':
					//set default text elements
					Content.content.e[el_id].type = 'text';
					Content.content.e[el_id].c['text'] = '';
					break;
					
					
				case 'image':
					//set default image elements
					Content.content.e[el_id].type = 'image/jpeg';
					Content.content.e[el_id].c['media_id'] = '';
					Content.content.e[el_id].c['media_position'] = 'center';
					Content.content.e[el_id].c['media_size'] = 'full';
					Content.content.e[el_id].c['media_gallery'] = '';
					
					break;
				case 'video':
					Content.content.e[el_id].type = 'video/mp4';
					Content.content.e[el_id].c['media_id'] = '';
					Content.content.e[el_id].c['media_position'] = 'center';
					Content.content.e[el_id].c['media_size'] = 'full';
					Content.content.e[el_id].c['media_gallery'] = '';
					break;
				case 'youtube':
					Content.content.e[el_id].c['video'] = '';
					break;
			}
			
			data = Content.content.e[el_id];
		}
		
		return data;
	}
	
}